import { render, staticRenderFns } from "./Aiib.vue?vue&type=template&id=370344c0&scoped=true&"
import script from "./Aiib.vue?vue&type=script&lang=js&"
export * from "./Aiib.vue?vue&type=script&lang=js&"
import style0 from "./Aiib.vue?vue&type=style&index=0&id=370344c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370344c0",
  null
  
)

export default component.exports